<template>
  <div id="accesskeys-modal">
    <el-dialog
      :title="$t('accessKeys.modal.title')"
      :before-close="beforeClose"
      :show-close="true"
      :visible.sync="dialogFormVisible"
      :close-on-press-escape="true"
      :close-on-click-modal="true"
      class="access-keys-dialog"
      center
    >
      <p class="access-keys-dialog__instructions">
        {{ $t('accessKeys.modal.instructions') }}
      </p>

      <h2 class="access-keys-dialog__sub-title">
        {{ $t('accessKeys.modal.listTitle') }}
      </h2>
      <el-tree :data="uiTree" :props="navigationKeysTreeStructure" accordion>
        <span slot-scope="{ node }">
          {{ `${node.label.split(':')[0]}${node.childNodes.length === 0 ? ':' : ''}` }}
          <span v-if="node.childNodes.length === 0" class="command">
            {{ node.label.split(':')[1] }}
          </span>
        </span>
      </el-tree>
    </el-dialog>
  </div>
</template>

<script>
import { NAVIGATION_ACCESS_KEYS } from '@/constants';

const createUITree = (obj, tree, translations) => {
  Object.keys(obj).forEach((key) => {
    const translationKey = `accessKeys.modal.listOfAccessKeys.${key.replace(' ', '')}`;
    const node = { label: translations.t(translationKey) };

    if (typeof obj[key] === 'object') {
      node.children = [];
      createUITree(obj[key], node.children, translations);
    } else {
      const command = `ctrl + option + ${obj[key]}`;
      node.label = `${node.label}: ${command}`;
    }

    tree.push(node);
  });

  return tree;
};

export default {
  name: 'AccessKeysModal',
  props: {
    display: false,
  },
  data() {
    return {
      navigationKeysTreeStructure: {
        children: 'children',
        label: 'label',
      },
      dialogFormVisible: this.display,
    };
  },
  computed: {
    uiTree() {
      return createUITree(NAVIGATION_ACCESS_KEYS, [], this.$i18n);
    },
  },
  methods: {
    beforeClose(done) {
      this.$emit('toggleDisplayAccessKeys');
      done();
    },
  },
};
</script>

<style scoped lang="scss">
@import '../scss/variables';
.el-dialog {
  width: 55%;
  &__body {
    padding: 30px;
  }

  &__title {
    font-size: $title-font-size;
  }

  &__wrapper {
    position: fixed;
    margin: 0;
  }

  .access-keys-dialog {
    &__instructions {
      margin-bottom: 16px;
    }

    &__sub-title {
      font-weight: bold;
      margin-bottom: 8px;
    }
  }

  .command {
    background: #ebeef5;
    border-radius: 4px;
    color: #f56c6c;
    font-family: monospace;
    margin-left: 4px;
    padding: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AccessKeysModal.vue